import { FC } from "react";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import { IContainerProps } from "../typos/container";
import ManageAds from "../pages/ManageAds";
import TransferProperties from "../pages/TransferProperties";

export interface IRoutes {
  path: string;
  active: boolean;
  isPrivate: boolean;
  container: FC<IContainerProps>;
}

export const arrRoutes: IRoutes[] = [
  {
    path: "/",
    active: true,
    isPrivate: false,
    container: Login,
  },
  {
    path: "/logout",
    active: true,
    isPrivate: true,
    container: Logout,
  },
  {
    path: "/dashboard",
    active: true,
    isPrivate: true,
    container: Home,
  },
  {
    path: "/ads",
    active: true,
    isPrivate: true,
    container: ManageAds,
  },
  {
    path: "/transfer-properties",
    active: true,
    isPrivate: true,
    container: TransferProperties,
  },
  {
    path: "/404",
    active: true,
    isPrivate: false,
    container: NotFound,
  },
];
